import { useEffect } from "react";

export default function NewRelicScript() {
  useEffect(() => {
    const sc_brand = process.env.REACT_APP_SC_BRAND || "agnostic";
    const node_env = process.env.REACT_APP_NODE_ENV;
    const name = process.env.REACT_APP_NEW_RELIC_APP_NAME || undefined;

    // console.log("NewRelicScript", {
    //   sc_brand,
    //   node_env,
    //   name,
    // });

    if (
      (node_env === "production" && (sc_brand === "sf" || sc_brand === "pdc" || sc_brand === "spr")) ||
      (node_env === "staging" && name === "Member Site Express - Test")
    ) {
      // Create script element
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.defer = false;
      script.src = `/scripts/nr-br-${sc_brand}.js`;

      // Try to insert after last <meta>
      const metas = document.getElementsByTagName("meta");
      if (metas && metas.length > 0) {
        const lastMeta = metas[metas.length - 1];
        if (lastMeta && lastMeta.parentNode) {
          lastMeta.parentNode.insertBefore(script, lastMeta.nextSibling);
          return;
        }
      }

      // Fallbacks
      // const head = document.getElementsByTagName("head")[0];
      // if (head) {
      //   head.appendChild(script);
      // } else {
      //   document.documentElement.appendChild(script);
      // }
    }
  }, []);

  return null; // This component doesn’t render UI
}
